import { render, staticRenderFns } from "./MyHighcharts.vue?vue&type=template&id=1bad2b91"
import script from "./MyHighcharts.vue?vue&type=script&lang=js"
export * from "./MyHighcharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports